/**
 * @file     useListingEntrySource.ts
 * @purpose  React subscription to the current standalone listing entry source.
 */
'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import {
  LISTING_ENTRY_EVENT,
  readCurrentListingEntry,
} from '@/services/auth/listingEntrySource';

export function useListingEntrySource(): { isInternalEntry: boolean } {
  const pathname = usePathname();
  const [isInternalEntry, setIsInternalEntry] = useState(false);

  useEffect(() => {
    setIsInternalEntry(readCurrentListingEntry(pathname));
    const update = (event: Event) => {
      const detail = (event as CustomEvent<{ pathname: string; internal: boolean }>).detail;
      if (detail?.pathname === pathname) setIsInternalEntry(detail.internal);
    };
    window.addEventListener(LISTING_ENTRY_EVENT, update);
    return () => window.removeEventListener(LISTING_ENTRY_EVENT, update);
  }, [pathname]);

  return { isInternalEntry };
}

